import { Skeleton } from "@/components/ui/skeleton";

export const HotelCardSkeleton: React.FC = () => {
  return (
    <div className="flex h-[350px] w-full flex-col items-start justify-start gap-3 rounded-lg p-3 shadow">
      <Skeleton className="h-[320px] w-full" />
      <div className="flex w-full gap-3">
        <Skeleton className="h-6 w-full" />
        <Skeleton className="h-6 w-[50px]" />
      </div>
      <Skeleton className="mt-auto h-10 w-52 rounded-2xl" />
    </div>
  );
};

export default HotelCardSkeleton;
